export default __webpack_public_path__ + "static/media/61-C2-Logo2.0dea6529.jpg";